import React, { useState } from 'react';
import axios from 'axios';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import '../../assets/scss/components/custom.scss';
import ContactArea from '../../pages/home/ContactArea';
import EdImg from '../../assets/img/team/ed.png';

const EDPortalForm = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    otp: '',
  });

  const [step, setStep] = useState('form'); // form, otp, verified
  const [response, setResponse] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const sendOtp = async () => {
    if (!form.name || !form.email || !form.phone) {
      setResponse("Please fill in your Name, Email, and Phone before sending OTP.");
      return;
    }
  
    try {
      const res = await axios.post('https://ricgop.online/api/send_otp.php', form);
      setResponse(res.data);
      if (res.data.includes('OTP Sent')) setStep('otp');
    } catch (error) {
      setResponse('Error sending OTP');
    }
  };

  const verifyOtp = async () => {
    try {
      const res = await axios.post('https://ricgop.online/api/verify_otp.php', {
        email: form.email,
        otp: form.otp,
      });
      setResponse(res.data);
      if (res.data.includes('OTP Verified')) setStep('verified');
    } catch (error) {
      setResponse('Error verifying OTP');
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('https://ricgop.online/api/submit_form.php', {
        email: form.email,
      });
      setResponse(res.data);
    } catch (error) {
      setResponse('Error submitting form');
    }
  };

  return (
<main>
  <Breadcrumb title="ED Portal" />
{/* <ContactArea /> */}
  <section className="it-contact-area it-appointments-inner-style py-5">
    <div className="container">
      <div className="row">
        {/* Left Column: Form */}
        <div className="col-lg-7 col-md-12 mb-4">
          <div className="it-contact-from-wrap shadow p-4 rounded bg-white h-100">
            <h3 className="it-section-title text-center pb-3">ED Portal</h3>
            <form onSubmit={submitForm}>
              <div className="row g-3">
                {/* Full Name */}
                <div className="col-12">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Full Name"
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Email */}
                <div className="col-12">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Email"
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Phone */}
                <div className="col-12">
                  <input
                    type="text"
                    name="phone"
                    className="form-control"
                    placeholder="Phone"
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Message */}
                <div className="col-12">
                  <textarea
                    name="message"
                    className="form-control"
                    placeholder="Write a message..."
                    rows="4"
                    onChange={handleChange}
                  ></textarea>
                </div>

                {/* Send OTP */}
                {step === 'form' && (
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-danger w-100"
                      onClick={sendOtp}
                    >
                      Send OTP
                    </button>
                  </div>
                )}

                {/* OTP & Verify */}
                {step === 'otp' && (
                  <>
                    <div className="col-12">
                      <input
                        type="text"
                        name="otp"
                        className="form-control"
                        placeholder="Enter OTP"
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-success w-100"
                        onClick={verifyOtp}
                      >
                        Verify OTP
                      </button>
                    </div>
                  </>
                )}

                {/* Final Submit */}
                {step === 'verified' && (
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-dark w-100"
                    >
                      <Button btnText="Submit" />
                    </button>
                  </div>
                )}

                {/* Response */}
                {response && (
                  <div className="col-12 pt-2">
                    <p className="text-success">{response}</p>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>

        {/* Right Column: ED Contact Details */}
        <div className="col-lg-5 col-md-12">
  <div className="card border-0 shadow-lg rounded-4 p-4 bg-light h-100">
    <div className="text-center mb-4">
      <img
        src={EdImg} // Replace with actual image
        alt="ED Profile"
        className="rounded-circle border border-3 border-primary shadow"
        style={{ width: '120px', height: '120px', objectFit: 'cover' }}
      />
      <h4 className="fw-semibold mt-3 mb-1 text-dark">Dr. Musfireh Siddiqeh</h4>
      <p className="text-muted mb-0">Executive Director</p>
    </div>

    <div className="px-2">
      <div className="d-flex align-items-start mb-3">
        <i className="bi bi-envelope-fill fs-5 text-primary me-3"></i>
        <div>
          <p className="mb-0 fw-medium text-muted">Email</p>
          <a href="mailto:ed@example.com" className="text-dark fw-semibold text-decoration-none">ed@ricgop.online</a>
        </div>
      </div>

      <div className="d-flex align-items-start mb-3">
        <i className="bi bi-telephone-fill fs-5 text-success me-3"></i>
        <div>
          <p className="mb-0 fw-medium text-muted">Phone</p>
          <p className="mb-0 text-dark fw-semibold">+92-51-9281111-9</p>
        </div>
      </div>

      <div className="d-flex align-items-start mb-3">
        <i className="bi bi-geo-alt-fill fs-5 text-danger me-3"></i>
        <div>
          <p className="mb-0 fw-medium text-muted">Address</p>
          <p className="mb-0 text-dark fw-semibold">
          Rawal Road, Rawalpindi, Pakistan
          </p>
        </div>
      </div>

      <div className="d-flex align-items-start">
        <i className="bi bi-clock-fill fs-5 text-warning me-3"></i>
        <div>
          <p className="mb-0 fw-medium text-muted">Office Hours</p>
          <p className="mb-0 text-dark fw-semibold">Mon - Fri, 9:00 AM - 5:00 PM</p>
        </div>
      </div>
    </div>
  </div>
</div>

      </div>
    </div>
  </section>
</main>



  );
};
export default EDPortalForm;
